/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.CollectionsRpc
 */
import * as References from './CollectionsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.CollectionsRpc#getRelevantPublishedIds
 */
export const GET_RELEVANT_PUBLISHED_IDS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_quality_rpc_CollectionsRpc_getRelevantPublishedIds';
export const GET_RELEVANT_PUBLISHED_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_RELEVANT_PUBLISHED_IDS_QUERY_FIELD_NAME,
  args: ['productType'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getRelevantPublishedIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.CollectionsRpc#getItems
 */
export const GET_ITEMS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_quality_rpc_CollectionsRpc_getItems';
export const GET_ITEMS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ITEMS_QUERY_FIELD_NAME,
  args: ['collectionId', 'published'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getItemsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.CollectionsRpc#getCollections
 */
export const GET_COLLECTIONS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_quality_rpc_CollectionsRpc_getCollections';
export const GET_COLLECTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COLLECTIONS_QUERY_FIELD_NAME,
  args: ['productType', 'published', 'locale'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getCollectionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});